import React, { useContext } from 'react';
import SocialNetworks from '../../../../hoc/components/social/social-networks';
import context from '../../../../hoc/context/product/context';
import RichText from '../../../../hoc/components/rich-text';
import InformationPanel from '../../../../hoc/components/information-panel';
import Section from '../../../../hoc/components/section/section';


const ConfirmationFooter = () => {
	const ctxt = useContext(context);
	return (
		<Section>
			<InformationPanel>
				<div className="flex flex-col gap-4">
					<p>
						<RichText html={ctxt.json.pages.confirmation.footer.title} />
					</p>
					<p>
						<RichText html={ctxt.json.pages.confirmation.footer.description} />
					</p>
					{ ctxt.json.pages.confirmation.footer.social &&
						<p>
							<RichText html={ctxt.json.pages.confirmation.footer.social} />
						</p>
					}
					<div className="flex w-full justify-center">
						<SocialNetworks items={ctxt.json.socialNetworks} />
					</div>
				</div>
			</InformationPanel>
		</Section>
	);
};

export default ConfirmationFooter;
